export default __webpack_public_path__ + "static/media/webdesign.34eccf00.png";